<div class="search-container">
  <mat-chip-grid #chipGrid aria-label="Enter search fields">
    <input
      placeholder="{{ 'scenario.grid.program.search' | translate }}"
      data-automation="grid-service-search-bar"
      [matChipInputFor]="chipGrid"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)"
      (keyup)="liveFilter($event)"
      [formControl]="search"
    />
  </mat-chip-grid>
  <br />
  <mat-chip-row
    *ngFor="let param of searchParams"
    (removed)="remove(param)"
    [editable]="true"
    (edited)="edit(param, $event)"
  >
    {{ param }}
    <button
      matChipRemove
      data-automation="grid-service-search-param"
      [attr.aria-label]="'remove ' + param"
    >
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip-row>
</div>
